import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ServerProvider} from "./serverContext/ServerProvider";
import {NavBarProvider} from "./components/navbar/NavBarContext";
import {BrowserRouter} from "react-router-dom";
import {SubNavBarProvider} from "./components/subnavbar/SubNavBarContext";
import {Notificator} from "./components/Notificator";
import {ResetProvider} from "./components/reset/ResetContext";
import {ModalProvider} from "./components/modal/ModalContext";

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Notificator>
                <ResetProvider>
                    <ServerProvider>
                        <ModalProvider>
                            <NavBarProvider>
                                <SubNavBarProvider>
                                    <App/>
                                </SubNavBarProvider>
                            </NavBarProvider>
                        </ModalProvider>
                    </ServerProvider>
                </ResetProvider>
            </Notificator>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
